module.exports = __webpack_public_path__ + "img/girl.6559cada.png";